import "./ListItem.css";
import * as React from "react";
import Logger from "../Log/Logger";
import api from "../../api";
import AppContext from "../AppContext";
import Partner from "../../../classes/Partner";
import { isMockMode, openOdooUrl } from "../../../mock/mockInterceptor";

type ListItemProps = {
  title: string;
  description?: string;
  // Record information to redirect to Odoo
  // and log email on the record
  model: string;
  res_id: number;
  logTitle: string;
  partner: Partner;
};

class ListItem extends React.Component<ListItemProps, {}> {
  openInOdoo = () => {
    const cids = this.context.getUserCompaniesString();
    const url = `${api.baseURL}/web#id=${this.props.res_id}&model=${this.props.model}&view_type=form${cids}`;
    openOdooUrl(url);
  };

  render() {
    const demo = isMockMode();
    return (
      <div
        className={`list-item-root-container${demo ? " list-item-root-container--demo" : ""}`}
        onClick={demo ? undefined : this.openInOdoo}
      >
        <div className="list-item-container">
          <div className="list-item-info-container">
            <div className="list-item-title-text">{this.props.title}</div>
            {this.props.description && <div className="list-item-description">{this.props.description}</div>}
          </div>
          <Logger
            resId={this.props.res_id}
            model={this.props.model}
            tooltipMailContent={this.props.logTitle}
            partner={this.props.partner}
          />
        </div>
      </div>
    );
  }
}

ListItem.contextType = AppContext;

export default ListItem;
